/* eslint-disable no-mixed-spaces-and-tabs */
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
// Containers
import Card from "../../../../../containers/Card/Card";
// Assets
import HowTo from "../../../../../assets/icons/howto.svg";
import Dialogue from "../../../../../assets/icons/dialogue.svg";

const Cases = ({
                   idExt,
                   isSouscription,
                   redirectToOnboarding,
                   setShowOfferModal,
                   setDisplayQuestions,
                   handleOpenNavItem
               }) => {
    const history = useHistory();
    const [questions, setQuestions] = useState(false);
    useEffect(() => {
        if (idExt == "B2C") setQuestions(true);
    }, []);
    const handlePlanDemand = () => {
        if (idExt === "B2C" && isSouscription === undefined) {
            null;
        } else if (idExt === "B2C" && !isSouscription) {
// Si le user est un client B2C et qu'il n'a pas de souscriptions
// on ouvre la modal des offres payantes
            setShowOfferModal(true);
        } else if (idExt === "BPCE-B2C") {
            setShowOfferModal(true);

        } else if (idExt === "B2C" && isSouscription) {
// Si c'est un client B2C et qu'il a une souscriptions
// on le redirige vers le bot de demande de rendez-vous
            history.push("/conversation");
        } else if (idExt !== "B2C") {
// Si le user à un idExt différent de B2C, c'est qu'il a entré un code d'activation
// et qu'il est rattaché à une entreprise (client B2B)
            history.push("/conversation");
        } else {
            setShowOfferModal(true);
        }
    };

    return (
        <div className="colonneCareManager cases">
            <div className={"colonneCareManager-title"}>
                <h1 className="titleMobile1">
                    Contactez votre
                </h1>
                <h2 className={"titleMobile2 nauticus"}>Care Manager
                </h2>
                <button className="button" onClick={handlePlanDemand}><p>+</p>{" "}
                    Nouvelle demande
                </button>
            </div>
            <ul className="list-cases">
                <Card/>
                {questions &&
                    <li className={"howTo"} id={"howTo"}
                        onClick={() => {
                            setDisplayQuestions(true);
                            handleOpenNavItem("accueil");
                        }}>
                        <img src={Dialogue} alt="continuer"/>
                        <a>Vos questions</a>
                    </li>
                }
                <li className={"howTo"} id={"howTo"} onClick={redirectToOnboarding}>
                    <img src={HowTo} alt="Comment ça marche ?"/>
                    <p>Comment ça marche ?</p>
                </li>
            </ul>
        </div>
    );
};

Cases.propTypes = {
    redirectToOnboarding: PropTypes.func,
    idExt: PropTypes.string,
    isSouscription: PropTypes.func,
    setShowOfferModal: PropTypes.func,
    setDisplayQuestions: PropTypes.func,
    handleOpenNavItem: PropTypes.func
};

export default Cases;
